export const providerDirectoryType = Object.freeze({
  SAEE: 1,
  USPQRP: 2,
});
